<script setup lang="ts">
import type { TableStoryblok } from "#storyblok-components";

defineProps<{ blok: TableStoryblok }>();
</script>

<template>
  <div
    v-editable="blok"
    class="site-viewport-container"
  >
    <table
      v-if="blok.table"
      :class="{ 'w-full': blok.isFullWidth }"
    >
      <thead>
        <tr>
          <th
            v-for="header in blok.table.thead"
            :key="header._uid"
          >
            {{ header.value }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in blok.table.tbody"
          :key="row._uid"
        >
          <td
            v-for="cell in row.body"
            :key="cell._uid"
          >
            {{ cell.value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="postcss" scoped>
table {
  @apply border-collapse table-auto;
}
th,
td {
  @apply border border-platform-border-2;
  @apply p-2;
  @apply text-left;
}
</style>
